let fancybox;

export function loadFancybox() {
    fancybox ??= Promise.all([
        import('@fancyapps/ui/dist/fancybox/fancybox.js'),
        import('@fancyapps/ui/dist/fancybox/l10n/de_DE.js'),
        import('@fancyapps/ui/dist/fancybox/fancybox.css'),
    ]).then(([{ Fancybox }, { de_DE }]) => ({
        Fancybox,
        de_DE,
    }));

    return fancybox;
}
